import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=6d886ef8&scoped=true&"
import script from "./BaseNavigation.vue?vue&type=script&lang=ts&"
export * from "./BaseNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BaseNavigation.vue?vue&type=style&index=0&id=6d886ef8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d886ef8",
  null
  
)

export default component.exports